export default __webpack_public_path__ + "static/media/promo-harry-in-hiding_01.b6dbe233.jpg";